import { t } from 'ttag';

import { RouterPreloader } from '@components/RouterPreloader';
import { ShopSettingsDeliveryMethodContainer } from '@containers/settings/ShopSettingsDeliveryMethod';
import { DeliveryService, PaymentMethodEnum } from '@newModels';
import { ShopSettingsDeliveryMethodProps } from '@components/settings/ShopSettingsDeliveryMethod';
import { logger } from '@utils/logger';

import { useShopSettingsDeliveryMethodsQuery } from './graphql.v4.generated';

type Props = Pick<ShopSettingsDeliveryMethodProps, 'theme'>;

export const ShopSettingsDeliveryMethodsContainer: React.FC<Props> = ({ theme }) => {
  const { data, loading, error } = useShopSettingsDeliveryMethodsQuery({
    context: { v4: true },
    fetchPolicy: 'cache-and-network',
  });

  if (loading) {
    return <RouterPreloader />;
  }

  if (error) {
    throw error;
  }

  if (data?.viewer?.deliverySettings && data.viewer.paymentMethods) {
    const {
      deliverySettings,
      paymentMethods,
      evoCards,
    } = data.viewer;

    const deliveryMethods = deliverySettings.map(
      (deliverySetting) => {
        let isHidden = false;
        let isHiddenDescription;
        const safePayment = paymentMethods.find(({ id }) => id === PaymentMethodEnum.SafePayment);

        //  Rozetka is disabled if safe payment disabled and cannot be enabled
        if (deliverySetting.deliveryService === DeliveryService.Rozetka) {
          if (safePayment && !safePayment.isEnabled && safePayment.isHidden) {
            isHidden = true;
            isHiddenDescription = t`Неможливо увімкнути Rozetka, оскільки ви не можете надсилати
            посилки Безпечною оплатою`;
          } else {
            logger.error('ShopSettingsDeliveryMethodsContainer: safe payment not found');
          }
        }

        return (
          <ShopSettingsDeliveryMethodContainer
            key={deliverySetting.deliveryService}
            theme={theme}
            {...deliverySetting}
            isHidden={isHidden}
            isHiddenDescription={isHiddenDescription}
            isSafePaymentEnabled={!!safePayment?.isEnabled}
            isPaymentCardAdded={!!evoCards?.length}
          />
        );
      },
    );

    return <>{deliveryMethods}</>;
  }

  throw new Error('Empty render');
};
